module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner-box",
    on: {
      "mouseover": _vm.boxMouseOver,
      "mouseout": _vm.boxMouseOut
    }
  }, [_c('div', {
    ref: "container",
    staticClass: "banner-container"
  }, [_c('div', {
    staticClass: "banner-movebg",
    style: ({
      backgroundImage: 'url(' + _vm.bannerData.bgUrl + ')',
      height: _vm.bannerLength * 100 + '%'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "banner-wrapper"
  }, _vm._l((_vm.bannerData.banners), function(banner, index) {
    return _c('div', {
      key: index,
      staticClass: "banner-slide"
    }, [_c('a', {
      staticStyle: {
        "display": "block"
      },
      style: ({
        cursor: banner.type != 0 ? 'pointer' : 'default'
      }),
      attrs: {
        "href": banner.src,
        "target": banner.target
      }
    }, [_c('div', {
      staticClass: "animate-wrapper"
    }, _vm._l((banner.imgs), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "animated animate-item",
        style: ({
          left: item.left + 'px',
          top: item.top + 'px'
        })
      }, [(item.type != 0) ? _c('a', {
        staticStyle: {
          "display": "block"
        },
        attrs: {
          "href": item.src,
          "target": item.target
        }
      }, [_c('img', {
        attrs: {
          "src": item.url,
          "alt": ""
        }
      })]) : _c('div', [_c('img', {
        attrs: {
          "src": item.url,
          "alt": ""
        }
      })])])
    }))])])
  }))]), _vm._v(" "), (_vm.bannerLength > 1) ? _c('div', {
    staticClass: "banner-pagination banner-pagination-bullets"
  }, _vm._l((_vm.bannerLength), function(item, index) {
    return _c('span', {
      key: index,
      staticClass: "banner-pagination-bullet",
      class: {
        'banner-pagination-bullet-active': _vm.activeIndex === index
      },
      on: {
        "click": function($event) {
          _vm.slideTo(index)
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.bannerLength > 1) ? _c('div', {
    staticClass: "banner-button-prev",
    on: {
      "click": _vm.slidePrev
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bannerLength > 1) ? _c('div', {
    staticClass: "banner-button-next",
    on: {
      "click": _vm.slideNext
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-13d4f6a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/banner.vue
// module id = 584
// module chunks = 1